import { ApolloClient, from } from '@apollo/client'
import { onError } from '@apollo/client/link/error'
import { setContext } from '@apollo/client/link/context'
import { createHttpLink, gql } from '@apollo/client/core'
import { IDimensions, customEvent } from '@dxp-module/common'
import { tokenService } from '@dxp-module/login'
import GeneralEvents from '../constants/GeneralEvents'
import cache from './cache'

type CustomGraphqlError = {
  code?: string
  message?: string
}

const typeDefs = gql`
  scalar MyAccount
`

const exceptOperationNames = (operationName?: string) => {
  if (!operationName) {
    return false
  }

  return (
    ['login', 'GetRegisterForm', 'GetTranslations', 'Register'].indexOf(
      operationName
    ) === -1
  )
}

const httpLink = (dimensions: IDimensions) =>
  createHttpLink({
    uri: String(import.meta.env.VITE_APP_GRAPHQL_SERVER_URL),
    headers: {
      'X-Brand': dimensions.brand,
      'X-Language': dimensions.language,
      'X-Region': dimensions.region,
      'X-Country': dimensions.country,
    },
  })

// TODO after XPD-19727 get these from autogenerated
const sessionErrorCodes: Array<string | undefined> = [
  'SESSION_NOT_FOUND',
  'SESSION_INVALID',
  'SESSION_EXPIRED',
  'SESSION_CLOSED',
]

const errorLink = onError(({ graphQLErrors }) => {
  if (graphQLErrors) {
    if (Array.isArray(graphQLErrors)) {
      graphQLErrors.forEach(graphQLError => {
        if (
          sessionErrorCodes.includes((graphQLError as CustomGraphqlError).code)
        ) {
          customEvent.emit(GeneralEvents.SESSION_ERROR, {})
          tokenService.removeCurrentToken()
        }
      })
    } else if (
      sessionErrorCodes.includes((graphQLErrors as CustomGraphqlError).code)
    ) {
      customEvent.emit(GeneralEvents.SESSION_ERROR, {})
      tokenService.removeCurrentToken()
    }
  }
})

const authLink = setContext((request, { headers }) => {
  return {
    headers: {
      ...headers,
      ...(exceptOperationNames(request.operationName) && {
        Authorization: tokenService.getCurrentToken() || '',
      }),
    },
  }
})

const generateApolloClient = (dimensions: IDimensions) =>
  new ApolloClient({
    connectToDevTools: import.meta.env.DEV,
    link: from([errorLink, authLink.concat(httpLink(dimensions))]),
    cache,
    typeDefs,
  })

export default generateApolloClient
